/*
 * @Author: edvardchen
 * @Date:   2016-10-10 17:51:05
 * @Last Modified by: qiyuanchen
 * @Last Modified time: 2019-12-30 20:01:42
 */

module.exports = require('@tencent/qb-article-util/lib/UA');
